import type { FaireProductEntity } from "../../entity_types/product";

export const p_qgzdpmse8k: FaireProductEntity = {
  token: "p_qgzdpmse8k",
  type: "product",
  name: '2.5" Glow-in-the-Dark Dumpling Squishy Stress Relief Toy',
  brandToken: "b_72ivqmkinu",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/8f5fcc47ad75fe3ca077745d7d988b4af8654ebbc8d21169d8d5487c52dce286.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce658a77ed2060054479077b7c64772f101eedf765310b08d7a68eba7efd5bdf.jpeg",
  ],
  priceDollars: 3.5,
  description:
    'Cute 2.5" dumpling squishy fidget toy with glow-in-the-dark appeal, glittery mystery colors.\n\nKey Features\nDisplay box includes assorted dumpling squishies in bright mystery-style colors.\nGlow-in-the-dark feature adds extra fun and strong impulse-buy appeal.\nEach piece measures approximately  2.5 x 2.5 x 1.5 inches and weighs 3.1 oz.\nEach dumpling comes in a steamer basket-style container for gift-ready presentation.\nGreat for toy stores, gift shops, party favors, and trending sensory toy collections.\n\nNote: The glitter inside is the glow material. Shake to distribute the glitter evenly, then expose to sunlight or bright light for a few hours to activate the glow.\n\nPrice on Faire is per Piece; case pack includes 24 pieces.',
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:26.589Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
